import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  ...zhLocale,
  title: '客户服务平台',
  login: {
    namePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    remember: '记住密码',
    btn: '登录',
    btnTip: '登录中',
    nameTip: '用户名不能为空',
    passwordTip: '密码不能为空',
    passwordLength: '密码最大长度为16位',
    noMatch: '确认密码与新密码不一致',
    loading: '正在登录...',
    checkMFA: '正在校验MFA...',
  },
  pwd: {
    oldPwd: '原密码',
    newPwd: '新密码',
    confirmPwd: '确认密码',
    oldPwdTip: '原密码不能为空',
    newPwdTip: '新密码不能为空',
    confirmPwdTip: '确认密码不能为空',
    passwordTip: '密码必须是8~16位，包含字母、数字、特殊字符(-_!@#$)',
    noMatch: '确认密码与新密码不一致',
    success: '密码修改成功，请重新登录！',
    btn: '修改',
    btnTip: '修改中',
    reset:  '重置',
  },
  header: {
    outBtn: '退出',
    setBtn: '设置',
    changeBtn: '修改密码',
    openMfa: '开启',
    closeMfa: '关闭',
  },
  common: {
    create: '创建',
    back: '返回',
    logType:'日志类型',
    keyword:'关键词',
    input:'请输入',
    operate:'操作',
    memo:'备注',
    time:'时间',
    account:'账号',
    botAccount:'bot账号',
    select:'请选择',
    startDate:'开始时间',
    endDate:'结束时间',
    startMonth:'开始月份',
    endMonth:'结束月份',
    and:'至',
    status:'状态',
    content:'内容',
    site:'站点',
    name:'名称',
    nickname:'昵称',
    description:'说明',
    invitationLink:'邀请链接',
    confirmDay: '结算间隔',
    default: '默认',
    memberRefundProp: '成员账号消费返利',
    day: '天',
    wallet:'钱包',
    address:'地址',
    batch:'批量',
    customer:'客户',
    agent:'代理商',
    messageType: '消息类型',
    sendTime: '发送时间',
    sendType: '发送类型',
    noticeContent:'通知内容',
    email:'邮箱',
    type:'类型',
    tableTime:'创建/修改时间',
    all:'全部',
    prepaid:'预付',
    agreed:'协议',
    phone:'电话',
    actualAmount:'实收金额',
    actualTotalAmount:'实收总金额',
    receivableTotalAmount:'应收总金额',
    date: '日期',
    range: '范围',
    payment:'付款',
    receipt:'收款',
    amount:'金额',
    amountTo:'合计',
    bill:'账单',
    total:'总',
    accounting:'会计',
    audit:'审核',
    operator:'操作者',
    member: '成员',
    quantity: '数量',
    quota: '配额',
    available: '可用',
    history: '历史',
    table: '列表',
    join: '加入',
    leave: '离开',
    method: '方法',
    month: '月份',
    service: '服务',
    currency: '货币',
    unit: '单位',
    cost: '费用',
    other: '其他',
    taxation: '税费',
    text: '文本',
    summary: '汇总',
    year:'年份',
    week:'星期',
    contacts: '联系人',
    level: '级别',
    code: '编码',
    region: '区域',
    strategy: '策略',
    hanwei:'汉为',
    picture:'图像',
    alias: '别名',
    label: '标签',
    tag: '标签',
    min: '最小',
    max: '最大',
    monthly: '当月',
    value: '值',
    staff: '员工',
    attribution: '归属',
    login: '登录',
    generate: '生成',
    group: '组',
    discountRate: '折扣率',
    scale: '比例',
    nonCDN: '非CDN资源',
    manage: '管理',
    role: '角色',
    password: '密码',
    avatar: '头像',
    way: '方式',
    option: '选项',
    settlement: '结算',
    increase: '添加',
    association: '关联',
    execute: '执行',
    update: '更新',
    version: '版本',
    salt: '盐值',
    root: '根',
    // directory: '目录',
    company: '公司',
    taxID: '税号',
    bank: '银行',
    prefix: '前缀',
    title: '标题',
    system: '系统',
    tip: '提示',
    sender: '发送人',
    function: '功能',
    result: '结果',
    fail: '失败',
    success: '成功',
    user: '用户',
    parentLevel: '所属父级',
    noParent: ' 无父级',
    discounts: '优惠',
    discount: '折扣',
    afterDiscount: '折后',
    USDToRMB: '美元转人民币',
    RMBToUSD: '人民币转美元',
    bucket: '桶路径',
    childLevel: '子级',
    invoice: '发票',
    number: '号码',
    original: '原始',
    actual: '实际',
    information: '信息',
    fillIn: '填写',
    submit: '提交',
    click: '点击',
    subtotal: '小计',
    exchangeRate: '汇率',
    varAmount: '增值税',
    commission: '手续费',
    automaticCalculation: '自动计算',
    additionalCost: '额外费用',
    offsetExpenses: '抵冲费用',
    payAmount: '实付金额',
    check: '核对',
    preview: '预览',
    reject: '驳回',
    reason: '原因',
    approve: '通过',
    image: '图片',
    price: '单价',
    used: '使用量',
    use: '使用',
    payee: '收款人',
    template: '模板',
    consumption: '消费',
    automatic: '自动',
    parent: '父级',
    report: '报告',
    details: '明细项',
    credential: '凭据',
    situation: '情况',
    allocation: '分配',
    owner: '所有者',
    open:'打开',
    device: '设备',
    preset: '预设',
    cc: '抄送人',
    feishu: '飞书',
    internal: '内部',
    query: '查询',
    bound: '已绑定',
    application: '应用',
    separate: '分离',
    append: '附加',
    target: '目标',
    change: '换绑',
    record: '记录',
    timeLimit: '期限',
    paymentObligations: '承付款',
    economize: '节省',
    estimatedValue: '估算值',
    proposal: '建议',
    refresh: '刷新',
    validity: '有效期',
    instance: '实例',
    database: "数据库",
    license: '许可证',
    currentGeneration: '当前一代',
    useRatio: '利用率',
    totalCommittedUsage: '总承诺使用量',
    consumedAmount: '已消耗用量',
    netSavings: '净节省',
    expenditure: '支出',
    costPrice: '成本价',
    subscribe: '订阅',
    unusedHours: '预留时间（未使用）',
    totalActualHours: '预留时间（已使用）',
    engine: '引擎',
    deployment: '部署',
    reservedHours: '预留覆盖时间',
    onDemandHours: '按需时间',
    totalRunningHours: '总运行小时数',
    onDemandCost: '按需成本',
    dimensionality: '维度',
    precharge:'预充',
    file: '文件',
    sales: '销售',
    balance: '余额',
    recharge: '充值',
    order: '订单',
    beforeAmount: '充值前余额',
    afterAmount: '充值后余额',
    proof: '凭证',
    field: '字段',
    permission: '权限',
    directory: '菜单',
    coverage:'覆盖量',
    usage:'用量',
    bucketName: '桶',
    project:'所属项目',
    sort:'排序',
    center:'中心'
  },
  btn:{
    bind: '绑定',
    unbind: '解绑',
    search: '查询',
    add: '新增',
    update: '编辑',
    delete: '删除',
    reset:'重置',
    register:'注册',
    cancel:'取 消',
    save:'保 存',
    configure:'配置',
    send:'发送',
    sync: '同步',
    download: '下载',
    disassociate: '解除关联',
    success: '操作成功!',
    details : '详情',
    check: '校验',
    export: '导出',
    import: '导入',
    upload: '上传',
    confirm:'确定',
    clear:'清空',
    enable:'启用',
    disable:'禁用',

  },
  home:{
    module1:'账单系统模块',
    module2:'客户商务平台',
    module3:'亚马逊云平台工具',
    module4:'技术知识库',
    module5:'PLS技术支持服务',
  },
  bill:{
    module1:'PayerID总数',
    module2:'LinkID总数',
    module3:'总成本',
    module4:'总积分',
    module5:'总退款',
  },
  sp: {
    basedOnPastData: '基于过去的数据',
    first: {
      title: '购买建议计划前',
      title3: '未覆盖按需支出',
      subtitle: '当前每月按需支出值',
    },
    second: {
      title: '购买建议计划之后',
      title2: '按需支出等值',
      title3: '平均覆盖率',
      subtitle: '每月支出估算值',
    },
    third: {
      title2: '净节省总额',
      subtitle: '每月节省估算值'
    },
  },
  ri: {
    first: {
      title: '总体购买建议',
      title2: '有效预留成本',
      title3: '总按需成本',
    },
    second: {
      title: '每月节省估算值',
      title2: '按需成本等值',
      title3: '平均覆盖率（小时）',
    },
    third: {
      title: '预计节省与按需费率',
      title2: '净节省总额',
    },
    fourth: {
      title2: '可能节省的总费用',
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/i18n/config/zh.js